import { EchoFilterKeyword } from '@/js/services/api/filter/types';

/**
 * Determines whether a piece of text matches the active keyword filter.
 *
 * - `Or` (default): the text matches if it contains at least one of the words.
 * - `And`: the text matches if it contains all of the words.
 *
 * Matching is case-insensitive and substring based, mirroring the highlight
 * logic in `TranscriptionChatMessage.vue`.
 */
export const textMatchesKeywords = (
    text: string,
    keywordFilter: EchoFilterKeyword | undefined | null
): boolean => {
    const words = (keywordFilter?.words ?? []).filter((w) => w.trim().length > 0);

    if (words.length === 0) {
        return true;
    }

    const haystack = text.toLowerCase();
    const matchers = words.map((w) => haystack.includes(w.toLowerCase()));

    return keywordFilter?.selectedWordSearchType === 'And'
        ? matchers.every(Boolean)
        : matchers.some(Boolean);
};
